import fetch from './';

type SubscriptionSize = {
	Id: number;
	DisplayName: string;
	MinimumStudentNumber: number;
	MaximumStudentNumber: number | null;
};

export const fetchSubscriptionSizes = () => {
 return fetch<SubscriptionSize[]>('/api/subscriptions/size', undefined, true);
};
